// extracted by mini-css-extract-plugin
module.exports = {"schedule":"ScheduleAndPrice_schedule__mnqd_"};